const DOTS_PER_INCH = 96;
const METERS_PER_INCH = 0.0254;
const MM_PER_INCH = METERS_PER_INCH * 1000;
const PIXEL_TO_POINT_FACTOR = 72 / 96;

/**
 * Converts millimeters to points.
 *
 * @param mmValue - value in [mm]
 * @return value in points
 */
export function convertMmToPoints (mmValue: number) {
  const valueInMeters = mmValue * 0.001;
  const valueInInch = valueInMeters / METERS_PER_INCH;
  const valueInPixels = valueInInch * DOTS_PER_INCH;
  return valueInPixels * PIXEL_TO_POINT_FACTOR;
}

/**
 * Converts px to millimeters.
 * Formula: length[mm] = pixel * 1inch / dpi
 *
 * @param pxValue - value in [px]
 * @return value in mm
 */
export function convertPxToMm (pxValue: number) {
  return  pxValue * MM_PER_INCH / DOTS_PER_INCH;
}

export function convertMmToPx (mmValue: number): number {
  return mmValue / MM_PER_INCH * DOTS_PER_INCH;
}
